import axios from 'axios';
import { buildKotPrintDocument, printKotDocuments, splitKotItems } from '../restaurant/kotPrintUtils';

const api = 'https://api.rcb.tdrsoftware.in/api';

export async function loadKotCatalog(customerId) {
  const id = encodeURIComponent(customerId);
  const readMenu = async (route, key, emptyMessage) => {
    try {
      const response = await axios.get(`${api}/${route}/${id}`);
      if (!Array.isArray(response.data[key])) throw new Error('Invalid menu response');
      return response.data[key];
    } catch (error) {
      if (error.response?.status === 404 && error.response.data?.message === emptyMessage) return [];
      throw error;
    }
  };
  const [food, wine] = await Promise.all([
    readMenu('getFoodData', 'food', 'No Food data'),
    readMenu('getWineData', 'wine', 'No Wine data found'),
  ]);
  return [
    ...food.map(item => ({ ...item, menuSource: 'food' })),
    ...wine.map(item => ({ ...item, menuSource: 'wine' })),
  ];
}

export function createKotReprintDocuments(order, catalog) {
  const { foodItems, barItems } = splitKotItems(order.foodItem || [], catalog);
  const timestamp = new Date(order.createdAt);
  const validTime = Number.isFinite(timestamp.getTime());
  return [
    { title: 'Reprint - Food KOT', items: foodItems },
    { title: 'Reprint - Beer / Bar KOT', items: barItems },
  ].filter(section => section.items.length).map(section => buildKotPrintDocument({
    ...section,
    tableNo: order.tableNo,
    kotNo: order.kotNo,
    serverName: order.serverName,
    date: validTime ? timestamp.toLocaleDateString('en-GB') : '',
    time: validTime ? timestamp.toLocaleTimeString('en-GB') : '',
    showPrices: true,
    totalBilling: order.totalBilling,
  }));
}

export async function reprintKotOrder(order, customerId, {
  loadCatalog = loadKotCatalog,
  printDocuments = printKotDocuments,
} = {}) {
  // Older KOT records did not retain categories. Read their menu metadata;
  // never rewrite historical records just to route a printed slip.
  const catalog = await loadCatalog(customerId);
  const documents = createKotReprintDocuments(order, catalog);
  if (!documents.length) return false;
  await printDocuments(documents);
  return true;
}
